import React, { useEffect, useState } from 'react';
import { RouteObject, useRoutes } from 'react-router';
import { useAuth } from '../hook/use-auth';
import { useRouter } from '../hook/use-router';
import Layout from '../layout';
import Login from '../page/login';
import NotFound from '../page/error/not-found';
import { menuRoutes } from './menu-routes';

const Loading = () => {
	return <div>loading</div>;
};

const noAuthRoutes: RouteObject[] = [
	{
		path: '/login',
		element: <Login />,
	},
	{
		path: '*',
		element: <Loading />,
	},
];

const routes: RouteObject[] = [
	{
		path: '/',
		element: <Layout />,
		children: [...menuRoutes],
	},
	{
		path: '*',
		element: <NotFound />,
	},
];

export const RouteContext = React.createContext(routes);

function RenderRoutes() {
	const { userId } = useAuth();
	const router = useRouter();
	const [currentRoutes, setCurrentRoutes] = useState(noAuthRoutes);
	const element = useRoutes(currentRoutes);

	useEffect(() => {
		if (userId) {
			setCurrentRoutes(routes);
			if (router.pathname === '/login') {
				router.replace(router.params.path || '/');
			}
		} else {
			setCurrentRoutes(noAuthRoutes);
			if (router.pathname !== '/login') {
				router.replace('/login', {
					path: router.pathname.replace(/^\//, ''),
				});
			}
		}
	}, [userId, router]);

	return element;
}

export { RenderRoutes, routes };
